import { httpRequest } from "../../utils/HttpRequest";
import { IUserFields, IUserDetial, IUserSearch } from "./userType"
import { IMealPage } from "@/types/AppTypes";
class UserService {
    async page(searchVo: IUserSearch) {
        const apiUrl = "/common/user/page";
        return await httpRequest.post<IMealPage<IUserDetial>>(apiUrl, searchVo);
    }
    async insert(searchVo: IUserFields) {
        const apiUrl = "/common/user/insert";
        return await httpRequest.post<boolean>(apiUrl, searchVo);
    }
    async update(searchVo: IUserFields) {
        const apiUrl = "/common/user/update";
        return await httpRequest.post<boolean>(apiUrl, searchVo);
    }
    async remove(id: string) {
        const apiUrl = `/common/user/remove/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    async export(userType: "0" | "1") {
        const apiUrl = `/common/user/export/${userType}`;
        return await httpRequest.getFile(apiUrl);
    }
}
export const userService = new UserService();
